<template>
	<div class="omapi-monsterleads__search-wrap">
		<span v-if="search" class="subtitle">
			{{ count }} search results for “{{ search }}”
		</span>
		<core-search-button
			class="omapi-campaign-table__search"
			:searchTerm="search"
			@searched="handleSearch"
			v-bind="$attrs"
		/>
	</div>

</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapState } = createNamespacedHelpers('monsterleads')

export default {
	props : {
		item : {
			default : 'leads',
			type    : String,
		},
	},
	computed : {
		...mapState([ 'search', 'count' ]),
	},
	methods : {
		...mapActions([ 'updateSearch', 'updateTagSearch' ]),
		handleSearch (search) {
			return 'leads' === this.item
				? this.updateSearch(search)
				: this.updateTagSearch(search)
		},
	},
}
</script>
<style lang="scss">
	.omapi-monsterleads__search-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
